import { Alert, Button, Modal, Text } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import { fetchJson } from '../../../../store/fetch';
import { ResponsiveCard } from '../../molecules/card/Card';
import { PageSectionForCards } from '../../molecules/pageSection/PageSection';

export function ConsentForPatientSatisfactionQuestionnaire() {
    const [showGiveConsentModal, setShowGiveConsentModal] = useState(false);
    const [hasPatientConsent, setHasPatientConsent] = useState(false);
    const [isCheckBoxChecked, setIsCheckBoxChecked] = useState(false);
    const agreeText = <Alert.Text>Ik ben akkoord met het delen van mijn gegevens</Alert.Text>;
    const title = 'Jouw mening telt';

    useEffect(() => {
        getHasPatientConsent();
    }, [showGiveConsentModal]);

    return (
        <PageSectionForCards
            chapterTitle="Zorg voor patiënten beter maken"
            md={12}
        >
            <ResponsiveCard
                body="Deel anoniem je ervaring en help ons om onze zorg te verbeteren"
                cardTitle={title}
                icon="none"
                lg={12}
                linksText={['Geef je mening']}
                onClick={() => setShowGiveConsentModal(true)}
            />

            <Modal
                isOpen={showGiveConsentModal}
                onClose={handleOnClose}
                size="medium"
                title={title}
            >
                <Modal.Header>{title}</Modal.Header>
                <Modal.CloseButton />
                <Modal.Body>
                    <Text>
                        Je mening geef je anoniem via een vragenlijst bij een onafhankelijke partij, Mediquest. Wij
                        delen hiervoor je naam en e-mailadres, dan sturen zij jou de vragenlijst. Je gegevens worden
                        alleen hiervoor gebruikt en daarna verwijderd.
                    </Text>
                    <Alert appearance="info">
                        {hasPatientConsent ? (
                            agreeText
                        ) : (
                            <Alert.Checkbox
                                checked={isCheckBoxChecked}
                                label={agreeText}
                                onChange={(e) => setIsCheckBoxChecked(e.target.checked)}
                            />
                        )}
                    </Alert>
                </Modal.Body>
                <Modal.Footer style={{ paddingTop: 0 }}>
                    {!hasPatientConsent && (
                        <Button
                            onClick={handleOnClose}
                            variant="outline"
                        >
                            Annuleer
                        </Button>
                    )}
                    <Button onClick={handleOnSave}>{hasPatientConsent ? 'Sluit' : 'Bewaar'}</Button>
                </Modal.Footer>
            </Modal>
        </PageSectionForCards>
    );

    async function getHasPatientConsent() {
        const result = await fetchJson('/api/patient/patientConsent', 'GET');
        setHasPatientConsent(result?.json?.hasPatientGivenConsent);
    }

    async function handleOnSave() {
        if (isCheckBoxChecked) {
            await fetchJson('/api/patient/patientConsent', 'POST');
        }
        setShowGiveConsentModal(false);
    }

    function handleOnClose() {
        setIsCheckBoxChecked(false);
        setShowGiveConsentModal(false);
    }
}
